<template>
  <v-container :fluid="!$vuetify.display.lgAndUp" class="pa-0">
    <v-card
      :elevation="$vuetify.display.mdAndUp ? 16 : 0"
      max-height="500"
      flat
      class="pa-6 rounded-xl d-flex"
      min-height="400"
      color="primary"
      style="
        background-image: linear-gradient(
          90.2deg,
          rgba(1, 47, 95, 1) -0.4%,
          rgba(56, 141, 217, 1) 106.1%
        );
      "
    >
      <!-- <v-row class="my-auto h-100" justify="center" align="center"> -->
      <v-col
        cols="12"
        md="6"
        class="h-100 my-auto d-flex flex-column justify-center align-center text-center"
      >
        <v-card-title class="text-h4 text-lg-h4">
          Una Plataforma <br />
          Control total, crecimiento exponencial
        </v-card-title>
        <v-card-text class="text-h6 text-lg-h5">
          Da el primer paso hacia el control total y un crecimiento sin
          precedentes. Agenda con nosotros un primer encuentro DEMO
        </v-card-text>
        <v-btn color="primary" size="large" rounded="pill" class="mt-4">
          Comienza Ahora
        </v-btn>
      </v-col>
      <!-- <v-col md="6" class="d-none d-md-block position-relative pa-0 " style="right: 0; top: 0; bottom: 0;"> -->
      <!-- </v-col> -->
      <!-- </v-row> -->
      <div
        v-if="$vuetify.display.mdAndUp"
        class="banner-img position-absolute right-0 top-0 bottom-0"
      >
        <NuxtImg
          src="/assets/home/banner1.webp"
          alt=""
          class="img2"
          fit="contain"
          format="webp"
          loading="lazy"
        />
        <NuxtImg
          src="/assets/home/banner2.webp"
          alt=""
          class="img1"
          fit="contain"
          format="webp"
          loading="lazy"
        />
        <NuxtImg
          src="/assets/home/banner3.webp"
          alt=""
          class="img3"
          fit="contain"
          format="webp"
          loading="lazy"
        />
        <NuxtImg
          src="/assets/home/banner4.webp"
          alt=""
          class="img4"
          fit="contain"
          format="webp"
          loading="lazy"
        />
      </div>
    </v-card>
  </v-container>
</template>

<script lang="ts" setup>
// Sin lógica adicional por ahora
</script>

<style scoped lang="scss">
@property --wave-offset {
  syntax: '<length-percentage>';
  inherits: false;
  initial-value: 0%;
}

@property --wave-scale {
  syntax: '<number>';
  inherits: false;
  initial-value: 1;
}

@keyframes banner-scale {
  0%, 30%, 100% { --wave-scale: 1; }
  15% { --wave-scale: 1.055; }
}

.banner-img {
  width: 54%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
  gap: 12px 12px;
  grid-auto-flow: row;
  grid-template-areas:
    ". img1 img2 img2 img2"
    "img3 img3 img2 img2 img2"
    "img3 img3 img2 img2 img2"
    "img3 img3 img4 img4 img4"
    ". . . . .";
  transform: rotateZ(-30deg) translateY(20%) translateX(10%);
  perspective: none;
}
.img1,
.img2,
.img3,
.img4 {
  // width: 100%;
  // height: 100%;
  border-radius: 12px;
  object-fit: contain;
  filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 1));
  --hover-scale: 1;
  --wave-scale: 1;
  transform: scale(var(--wave-scale)) scale(var(--hover-scale));
  animation: banner-scale 4s ease-in-out infinite;
  animation-fill-mode: both;
  transition: transform 360ms cubic-bezier(.22,.9,.35,1), filter 300ms ease;
  will-change: transform, filter;
}
.img1 { grid-area: img1; margin-top: auto; animation-delay: 0.5s; width: 100%; }
.img2 { grid-area: img2; animation-delay: 1s; height: 100%; margin-right: auto; }
.img3 { grid-area: img3; animation-delay: 0s; margin-bottom: auto; width: 100%; }
.img4 { grid-area: img4; animation-delay: 0.5s; width: 100%; }
.banner-img {
  transition: transform 350ms cubic-bezier(.22,.9,.35,1);
  will-change: transform;
}

.banner-img:hover {
  transform: rotateZ(-30deg) translateY(20%) translateX(10%);
}

.banner-img:hover .img1,
.banner-img:hover .img2,
.banner-img:hover .img3,
.banner-img:hover .img4 {
  animation: none;
  --wave-scale: 1;
}

/* animación suave por cada imagen dentro del grid, con ligero stagger visual */
.img1,
.img2,
.img3,
.img4 {
  transition: transform 360ms cubic-bezier(.22,.9,.35,1), filter 300ms ease;
  will-change: transform, filter;
}

.img1:hover { --hover-scale: 1.06; filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.35)); }
.img2:hover { --hover-scale: 1.045; filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.35)); }
.img3:hover { --hover-scale: 1.05; filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.35)); }
.img4:hover { --hover-scale: 1.04; filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.35)); }
</style>
